import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import PageHeader from './PageHeader';
import SummaryTab from './commission-tabs/SummaryTab';
import MainCommissionsTab from './commission-tabs/MainCommissionsTab';
import StrategicCommissionsTab from './commission-tabs/StrategicCommissionsTab';
import CashbackStrategicTab from './commission-tabs/CashbackStrategicTab';
import CashbackTab from './commission-tabs/CashbackTab';
import ComplaintsTab from './commission-tabs/ComplaintsTab';
import SupportTab from './commission-tabs/SupportTab';
import AdminTab from './commission-tabs/AdminTab';
import LeadsTab from './commission-tabs/LeadsTab';
import LeadsNewTab from './commission-tabs/LeadsNewTab';
import CallCenterCommissionsTab from './commission-tabs/CallCenterCommissionsTab';
import MultisportTab from './commission-tabs/MultisportTab';
import TeamleaderTab from './commission-tabs/TeamleaderTab';

export default function CommissionsWithTabs({ userRole, users, companies, currentUserId, isDarkMode }) {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(userRole === 'podpora' ? 'support' : 'summary');
  const [tabSwitchCount, setTabSwitchCount] = useState(0);
  const [complaintPrefill, setComplaintPrefill] = useState(null);

  const handleSwitchToComplaints = (companyName, ico) => {
    setComplaintPrefill({ companyName, ico });
    setActiveTab('complaints');
    setTabSwitchCount(prev => prev + 1);
  };

  const tabs = userRole === 'podpora'
    ? [
        { id: 'complaints', label: 'Reklamace', icon: '⚠️' },
        { id: 'support', label: 'Podpora', icon: '🛠️' }
      ]
    : [
        { id: 'summary', label: 'Shrnutí', icon: '📊' },
        { id: 'main', label: 'Hlavní provize', icon: '💰' },
        { id: 'strategic', label: 'Strategická provize', icon: '🎯' },
        { id: 'cashback', label: 'Cashback', icon: '↩️' },
        { id: 'cashback-strategic', label: 'Cashback - strategické provize', icon: '🔄' },
        ...(userRole === 'admin' || userRole === 'podpora' ? [{ id: 'support', label: 'Podpora', icon: '🛠️' }] : []),
        { id: 'leads', label: 'Leady', icon: '📋' },
        { id: 'leads-new', label: 'Leady - nové', icon: '🧾' },
        ...(userRole === 'admin' || userRole === 'callcentrum' ? [{ id: 'callcentrum', label: 'Callcentrum', icon: '📞' }] : []),
        { id: 'multisport', label: 'Multisport', icon: '🏋️' },
        { id: 'teamleader', label: 'Můj team', icon: '👥' },
        { id: 'complaints', label: 'Reklamace', icon: '⚠️' },
        ...(userRole === 'admin' ? [{ id: 'admin', label: 'ADMIN', icon: '⚙️' }] : [])
      ];

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'summary':
        return <SummaryTab key={`summary-${tabSwitchCount}`} userRole={userRole} currentUserId={currentUserId} isDarkMode={isDarkMode} />;
      case 'main':
        return <MainCommissionsTab key={`main-${tabSwitchCount}`} userRole={userRole} users={users} currentUserId={currentUserId} isDarkMode={isDarkMode} />;
      case 'strategic':
        return <StrategicCommissionsTab key={`strategic-${tabSwitchCount}`} userRole={userRole} users={users} currentUserId={currentUserId} isDarkMode={isDarkMode} />;
      case 'cashback':
        return <CashbackTab key={`cashback-${tabSwitchCount}`} userRole={userRole} users={users} currentUserId={currentUserId} isDarkMode={isDarkMode} />;
      case 'cashback-strategic':
        return <CashbackStrategicTab key={`cashback-strategic-${tabSwitchCount}`} userRole={userRole} users={users} currentUserId={currentUserId} isDarkMode={isDarkMode} />;
      case 'complaints':
        return <ComplaintsTab key={`complaints-${tabSwitchCount}`} userRole={userRole} currentUserId={currentUserId} isDarkMode={isDarkMode} prefillCompany={complaintPrefill} />;
      case 'support':
        return <SupportTab key={`support-${tabSwitchCount}`} userRole={userRole} users={users} currentUserId={currentUserId} isDarkMode={isDarkMode} />;
      case 'leads':
        return <LeadsTab key={`leads-${tabSwitchCount}`} userRole={userRole} users={users} currentUserId={currentUserId} isDarkMode={isDarkMode} onSwitchToComplaints={handleSwitchToComplaints} />;
      case 'leads-new':
        return <LeadsNewTab key={`leads-new-${tabSwitchCount}`} userRole={userRole} users={users} currentUserId={currentUserId} isDarkMode={isDarkMode} />;
      case 'callcentrum':
        return <CallCenterCommissionsTab key={`callcentrum-${tabSwitchCount}`} userRole={userRole} users={users} currentUserId={currentUserId} isDarkMode={isDarkMode} />;
      case 'multisport':
        return <MultisportTab key={`multisport-${tabSwitchCount}`} userRole={userRole} users={users} currentUserId={currentUserId} isDarkMode={isDarkMode} />;
      case 'teamleader':
        return <TeamleaderTab key={`teamleader-${tabSwitchCount}`} userRole={userRole} users={users} currentUserId={currentUserId} isDarkMode={isDarkMode} />;
      case 'admin':
        return <AdminTab key={`admin-${tabSwitchCount}`} userRole={userRole} users={users} companies={companies} currentUserId={currentUserId} isDarkMode={isDarkMode} />;
      default:
        return <SummaryTab key={`summary-${tabSwitchCount}`} userRole={userRole} currentUserId={currentUserId} />;
    }
  };

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-gradient-to-br from-gray-900 to-gray-800' : 'bg-gradient-to-br from-gray-100 to-blue-100'} py-10`}>
      <div className="w-[98vw] max-w-[1800px] mx-auto px-4">
        <PageHeader
          title="💰 Systém provizí"
        />
        
        <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} p-6 rounded-lg shadow`}>

          {/* Karty navigace */}
          <div className="mb-6">
            <div className={`border-b ${isDarkMode ? 'border-gray-600' : 'border-gray-200'}`}>
              <nav className="-mb-px flex space-x-8">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => {
                      if (tab.id !== 'complaints') setComplaintPrefill(null);
                      setActiveTab(tab.id);
                      setTabSwitchCount(prev => prev + 1);
                    }}
                    className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
                      activeTab === tab.id
                        ? `border-blue-500 ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`
                        : `border-transparent ${isDarkMode ? 'text-gray-400 hover:text-gray-200 hover:border-gray-500' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'}`
                    }`}
                  >
                    <span className="mr-2">{tab.icon}</span>
                    {tab.label}
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Obsah aktivní karty */}
          <div className="mt-6">
            {renderActiveTab()}
          </div>
        </div>
      </div>
    </div>
  );
}